export default __webpack_public_path__ + "static/media/defaultUser.2fda6558.png";